module.exports = __webpack_public_path__ + "img/print_footprint@2x.4c8981a.webp";